"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _CloseInverse = _interopRequireDefault(require("./CloseInverse"));
var _default = (0, _styledComponents["default"])(_CloseInverse["default"]).withConfig({
  displayName: "CloseInverseRight",
  componentId: "sc-oxf9ky-0"
})(["top:-25px;width:50px;height:50px;right:-25px;position:absolute;"]);
exports["default"] = _default;
//# sourceMappingURL=CloseInverseRight.js.map